<div class="modal-content border-0 something-went-wrong">
  <div class="modal-body text-center">
    <svg class="error-icon" viewBox="0 0 80 80" aria-hidden="true">
      <circle cx="40" cy="40" r="37" />
      <path d="M27 27 L53 53 M53 27 L27 53" />
    </svg>
    <h4 class="title">Something went wrong</h4>
    <p class="message">We were unable to reach the server. Please reload the page and try again.</p>
    <button type="button" class="btn btn-primary rounded-pill reload-btn" (click)="reload()">Reload</button>
  </div>
</div>
